import { render, staticRenderFns } from "./electric-charge.vue?vue&type=template&id=aca1b20a&"
import script from "./electric-charge.vue?vue&type=script&lang=js&"
export * from "./electric-charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports